import type { DataCollection } from '@sentry/core'

export function normalizeSampleRate(raw: number | string | undefined): number {
  if (typeof raw === 'number') {
    if (!Number.isFinite(raw)) return 0
    if (raw <= 0) return 0
    if (raw >= 1) return 1
    return raw
  }

  if (typeof raw === 'string') {
    const parsed = Number(raw)
    if (!Number.isFinite(parsed)) return 0
    if (parsed <= 0) return 0
    if (parsed >= 1) return 1
    return parsed
  }

  return 0
}

// Sentry v11 collects everything unless told otherwise. This is the v10 `sendDefaultPii: false`
// baseline, except query strings are dropped entirely: auth URLs carry OTPs and emails.
export const sentryDataCollection = {
  userInfo: false,
  cookies: false,
  httpHeaders: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
  httpBodies: [],
  urlQueryParams: false,
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  graphQL: { document: false, variables: false },
} satisfies DataCollection
